import React, { Fragment, useEffect, useRef, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import classes from "./header.module.css";
import { useSelector } from "react-redux";
import EyeSpyFXLogo from '../../../assets/eyespyfx-logo.png';
import ParfasLogo from "../../../assets/parfas-logo.png"
import ResureLogo from "../../../assets/resure-logo.png"
import KnowioLogo from "../../../assets/knowio-logo.png"
import PortalLogo from "../../../assets/portal-logo.png"
import NotificationDropDownList from "../Cards/NotificationDropDownList";
import NotificationBell from "../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Header/__Notifications.svg"

import { Link, useLocation } from "react-router-dom";
import Modal from "../../Modal/Modal";
import SetTag from "../../Modal/ModalLayouts/SetTag";
import { Audio, BallTriangle, Bars, Circles, Grid, Hearts, Oval, Puff, Rings, SpinningCircles, TailSpin, ThreeDots } from "react-loading-icons";
import { addGroup, changeCamectIntegration, createSite, getGroups, getGroupUsers, listPartneredArcs, purchaseCCTVLicence, grantDemoCCTVLicence, checkSiteExists, PowerSearchAPI } from "../../../Api Methods/Api";
import UserList from '../../../Pages/User Management/UserManagementList';
import { authActions } from "../../../store/auth-Slice";
import { useNavigate } from "react-router-dom";
import { serviceActions } from "../../../store/service-Slice";
import { uiActions } from "../../../store/ui-slice";
import DataManager from "../../../hooks/DataManager";
import { single } from "rxjs";
import logoutIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/logout.png'
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import AddPortalUser from "../../../Pages/Groups/AddPortalUser";
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { FloatLabel } from 'primereact/floatlabel';
import { Divider } from 'primereact/divider';
import { Checkbox } from 'primereact/checkbox';
import Lottie from "lottie-react";
import successAnim from '../../../assets/animations/success.json'
import failAnim from '../../../assets/animations/fail.json'
import CreateUserForm from "../../../Pages/User Management/CreateUserForm";
import CreateUser from "../../../Register/CreateUser";
import CreateUserPortal from "../../../Register/CreateUserPortal";
import { create } from "@mui/material/styles/createTransitions";
import useSetCookie from "../../hooks/UseSetCookie";
import { AutoComplete } from "primereact/autocomplete";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";


const pages = ["Dashboard", "AllSites", "Offline", "Users", "Groups", "Padlocks", "Keyboxes", "Sensors", "UserSites", "Activity", "SiteView"];


const Header = ({ isSocketConnected, findClosestToEnd }) => {
    const companyName = useSelector(state => state.auth.companyName);
    const [visible, setIsVisible] = useState(false)
    const [addUserStep1Visible, setAddUserStep1Visible] = useState(false)
    const [addUserStep2Visible, setAddUserStep2Visible] = useState(false)
    const [groups, setGroups] = useState([])
    const [selectedGroup, setSelectedGroup] = useState(null)
    const [groupID, setGroupID] = useState(null)

    const [createSiteStep1Visible, setCreateSiteStep1Visible] = useState(false)
    const [createSiteSuccessVisible, setCreateSiteSuccessVisible] = useState(false)
    const [createSiteFailVisible, setCreateSiteFailVisible] = useState(false)
    const [createSiteForGroup, setCreateSiteForGroup] = useState(null)
    const [newSiteUUID, setNewSiteUUID] = useState("")

    const [successVisible, setSuccessVisible] = useState(false)
    const [failVisible, setFailVisible] = useState(false)
    const [showAddUserFail, setShowAddUserFail] = useState(false);
    const [genericSuccessVisible, setGenericSuccessVisible] = useState(false)
    const [genericFailVisible, setGenericFailVisible] = useState(false)
    const [failCreateUserVisible, setFailCreateUserVisible] = useState(false)
    const [createUserVisible, setCreateUserVisible] = useState(false)
    const [createSingleUserVisible, setCreateSingleUserVisible] = useState(false)
    const [showSettingsMenu, setShowSettingsMenu] = useState(false)
    const [showCCTVPurchase, setShowCCTVPurchase] = useState(false)
    const settingsMenuRef = useRef(null)
    const [isDark, setIsDark] = useState(() => localStorage.getItem('theme') === 'dark')
    const [portalUsersVisible, setPortalUsersVisible] = useState(false)
    const [portalUsers, setPortalUsers] = useState([])
    const [portalUsersLoading, setPortalUsersLoading] = useState(false)
    const [portalUsersUpdate, setPortalUsersUpdate] = useState(0)
    const [siteSearchTerm, setSiteSearchTerm] = useState("");
    const [siteSuggestions, setSiteSuggestions] = useState([]);
    const [siteError, setSiteError] = useState("");
    const skipNextSearchClear = useRef(false);

    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const DeviceUUID = useSelector(state => state.auth.DeviceUUID);
    const role = useSelector(state => state.auth.role);
    const [update, setUpdate] = useState(0);


    const myGroup = groups.find(g => g.name === companyName);
    const isEyeSpyFX = companyName === "EyeSpyFX";
    const showMonitoringStation = myGroup?.supportsMonitoring === 1;
    const supportEnabled = myGroup?.supportEnabled === 1;
    const siteCreationEnabled = myGroup?.allowSiteCreation === 1;
    const groupCreationEnabled = myGroup?.allowGroupCreation === 1;
    const billingEnabled = myGroup?.billingEnabled;
    // RE:SURE and its subgroups have a hardcoded 100,000 CCTV licences on the backend (see
    // SelectCCTVIntegration.js), so purchasing more is meaningless for them. Everyone else needs
    // the group-level 'cctvLicensingEnabled' permission to see the purchase option at all.
    const isRESUREGroup = companyName === "RE:SURE" || (myGroup?.groupPath || '').includes("RE:SURE");
    const showPurchaseCCTVLicence = !isRESUREGroup && Boolean(myGroup?.cctvLicensingEnabled);

    const [isCreateGroupVisible, setIsCreateGroupVisible] = useState(false)
    const [createGroupName, setCreateGroupName] = useState('')
    const [createGroupParent, setCreateGroupParent] = useState(null)
    const [createGroupMonitoringStation, setCreateGroupMonitoringStation] = useState(null)
    const [monitoringStationOptions, setMonitoringStationOptions] = useState([])
    const [createGroupSuccessVisible, setCreateGroupSuccessVisible] = useState(false)
    const [createGroupFailVisible, setCreateGroupFailVisible] = useState(false)
    const [createGroupFailMessage, setCreateGroupFailMessage] = useState("")
    const [newGroupObject, setNewGroupObject] = useState({})

    const [genericSuccessMessage, setGenericSuccessMessage] = useState("")
    const [genericFailMessage, setGenericFailMessage] = useState("")

    const [newGroupSupportEnabled, setNewGroupSupportEnabled] = useState(false)
    const [newGroupAllowSiteCreation, setNewGroupAllowSiteCreation] = useState(false)
    const [newGroupBillingEnabled, setNewGroupBillingEnabled] = useState(billingEnabled)
    const [newGroupAllowGroupCreation, setNewGroupAllowGroupCreation] = useState(false)
    const [newGroupIsOnDD, setNewGroupIsOnDD] = useState(false)
    const [newGroupIsBillableAccount, setNewGroupIsBillableAccount] = useState(false)
    const [newGroupIsWhitelabel, setNewGroupIsWhitelabel] = useState(false)
    const [newGroupUserInvitesEnabled, setNewGroupUserInvitesEnabled] = useState(false)
    const [newGroupCCTVLicensingEnabled, setNewGroupCCTVLicensingEnabled] = useState(false)

    const [selectedGroupForLicence, setSelectedGroupForLicence] = useState(null)
    const [selectedCCTVLicenceQuantity, setSelectedCCTVLicenceQuantity] = useState(0)

    const apiData = {
        token,
        client
    }

    const dataManager = new DataManager();

    const singleDeviceHeaderData = useSelector(state => state.service.singleDeviceHeaderData);
    const [headerData, setHeaderData] = useState(singleDeviceHeaderData);

    const dispatch = useDispatch();

    useEffect(() => {
        setHeaderData(singleDeviceHeaderData);
    }, [singleDeviceHeaderData, update])

    useEffect(() => {
        document.documentElement.setAttribute('data-theme', isDark ? 'dark' : 'light');
        localStorage.setItem('theme', isDark ? 'dark' : 'light');
    }, [isDark])

    const ModalDialog = useRef();

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();
    }

    const userName = useSelector(state => state.auth.userName);
    const userEmail = useSelector(state => state.auth.email);


    const userID = useSelector(state => state.auth.userID);

    const navigate = useNavigate();

    const location = useLocation();
    const pathArray = location.pathname.split('/');
    const currentpage = findClosestToEnd(pages, pathArray);
    let header;
    switch (currentpage) {

        case "Users":
        case "Activity":
        case "UserSites":
           
            break
        case "Dashboard":
            
            break
        case "AllSites":
            
            break
        case "Offline":
            
            break
        case "Groups":
            
            break
        case "Padlocks":
            
            break
        case "Sensors":
            
            break
        case "Keyboxes":
           
            break
        
        case "SiteView":
            
            break
    }

    const LoadGroups = async () => {
        const _groups = await getGroups(apiData, dispatch)
        setGroups([..._groups].sort((a, b) =>
            a.name.localeCompare(b.name)
        ))
    }

    const LoadArcs = async () => {
        const response = await listPartneredArcs(apiData, dispatch)
        if (response?.data) {
            const options = [
                { id: 0, name: 'Self monitored' },
                ...response.data.filter(arc => arc.name !== "Monitor Test" && arc.name !== "Monitor Test 2" && arc.platform === 'sentinel')
            ]
            setMonitoringStationOptions(options)
        }
    }

    useEffect(() => {
        LoadGroups()
        LoadArcs()
    }, [])

    useEffect(() => {
        if (portalUsersUpdate === 0) return
        const allGroups = JSON.parse(localStorage.getItem('groups') || '[]')
        const companyGroup = allGroups.find(g => g.name === companyName)
        if (!companyGroup) return
        const refetch = async () => {
            try {
                const response = await getGroupUsers(apiData, companyGroup.id, dispatch)
                setPortalUsers(response?.data ?? [])
            } catch {
                setPortalUsers([])
            }
        }
        refetch()
    }, [portalUsersUpdate])

    const HandleLogout = () => {
        localStorage.clear();
        sessionStorage.clear();
        dispatch(serviceActions.resetFilters())
        dispatch(serviceActions.resetGSFilters())
        navigate('/logout')
    }

    const handleReportAnIssue = () => {
        window.open("https://support.inniovate.com/portal/en/newticket", "_blank");
    }

    const handlePortalHelp = () => {
        window.open("https://knowio.app/support/portal", "_blank")
    }

    const HandleWhatsNew = () => {
        setIsVisible(true)
    }

    const HandleAddUser = () => {
        setAddUserStep2Visible(true)
    }

    const HandleChooseGroup = () => {
        setAddUserStep1Visible(true)
    }

    const HandleCreateSite = () => {
        setCreateSiteStep1Visible(true)
    }

    // Camect changelog items are only relevant to EyeSpyFX, RE:SURE and its subgroups - mirrors the showCamect check in SiteView.js
    const showCamect = isEyeSpyFX || isRESUREGroup;

    const changelogs = [
        // {
        //     date: "Sep 25th, 2025",
        //     content: (
        //         <div className="space-y-4">
        //             <h3>✨ New Features</h3>
        //             <ul className="list-disc pl-5">
        //             <li><strong>Mass User Creation:</strong> Upload a <code>.csv</code> file to quickly create multiple user accounts.</li>
        //             <li><strong>User Onboarding Details:</strong> Profiles will now indicate whether the user joined via self-registration, an invite, or admin creation.</li>
        //             <li><strong>Dashboard Improvements:</strong> Dashboard items now show an 'Active count' to compare devices on an 'active' site vs total count.</li>
        //             <li><strong>Improved visibility & tracking:</strong>  
        //                 <ul className="list-disc pl-5">
        //                     <li>From now on, newly added <em>Scheduled Actions, Reminders, Site Access Restrictions, and Temporary schedules</em> will display 'Created by' and 'Date created'.</li>
        //                     <li>Newly added 'Devices' (AJAX, Dahua, Hikvision and AIBox) will now display 'Added by' and 'Date added' details.</li>
        //                 </ul>
        //             </li>
        //             <li><strong>User Management Enhancements:</strong>  
        //                 <ul className="list-disc pl-5">
        //                 <li>Ability to edit user names and email addresses.</li>
        //                 <li>Default page size on <em>Users</em> page increased to 100.</li>
        //                 </ul>
        //             </li>
        //             </ul>

        //             <br></br>

        //             <h3>🛠️ Improvements</h3>
        //             <ul className="list-disc pl-5">
        //             <li><em>Create Scheduled Action</em> now displays the pin name instead of using a clickable button.</li>
        //             <li><em>Users</em> page updated: “Last logged in” column has been replaced with “Account created”.</li>
        //             <li><em>Controllers</em> & <em>Offline controllers</em> page updated: Count values can now be clicked to filter the list.</li> 
        //             </ul>

        //             <br></br>

        //             <h3>🐞 Fixes</h3>
        //             <ul className="list-disc pl-5">
        //             <li>Fixed logo rendering issue in the sidenav bar.</li>
        //             <li>Fixed Active switch behavior on <em>Controllers</em> and <em>Offline Controllers</em> pages.</li>
        //             </ul>
        //         </div>
        //     )
        // },
        // {
        //     date: "Oct 13th, 2025",
        //     content: (
        //         <div className="space-y-4">
        //             <h3>✨ New Features</h3>
        //             <li>   Introduced new <em>'Padlock/Keybox' entity</em> page - View detailed padlock information and configuration by clicking on a Padlock/Keybox in the <em>Padlocks</em> or <em>Keybox</em> pages </li>
        //             <li>   Introduced new <em>Scheduled sites</em> page - View which sites are on schedule & up to 4 schedules per site!</li>
        //             <li>   <em>App View :</em> Added 'Gateway' logo & battery level to the App View to match mobile app UI</li>
        //             <li>   Added the ability to name a Padlock or Keybox, outside of the output name.</li>
        //             <li>   Improved billing 
        //                  <ul className="list-disc pl-5">
        //                     <li>        • Added the ability to set a Padlock or Keybox as billable or non-billable.</li>
        //                     <li>        • Added the ability to assign an owner and specify who pays for each Padlock/Keybox</li>
        //                     <li>        • Added new billable counts for Padlocks and Keyboxes in the <em>Dashboard</em> and <em>Group</em> pages, to quickly see how many Padlocks/Keyboxes are being paid for</li>
        //                 </ul>
        //             </li>

        //             <br></br>
        //             <h3>🛠️ Improvements</h3>
        //             <li>    Sites set to 'Inactive' will no longer receive Smart Reminders or Scheduled Actions</li>
        //             <li>    Made all pop-ups moveable by clicking and dragging on the top</li>
        //             <li>    Updated table columns on <em>Padlocks</em> & <em>Keybox</em> lists</li>
        //                 <ul className="list-disc pl-5">
        //                     <li>    • "Owned by" column has been renamed to "Used by"</li>
        //                     <li>    • "Lock name" column now shows internal name assigned to a Padlock/Keybox, "Linked output" will show the name of the output the lock is assigned to.</li>
        //                     <li>    • Battery status "0%" is now displayed as "?" to match the mobile app.</li>
        //                 </ul>
        //             <li>    Updated the text in the 'Create user' dropdown for clearer options.</li>
        //             <br></br>
        //             <h3>🐞 Fixes</h3>
        //                 <li>    Fixed an issue with <em>Rules</em> page, where removing a 'Scheduled Action' would cause the list to display in the wrong order</li>
        //                 <li>    Fixed an issue where the maximum length of a 'Duration' pincode would not be displayed before attempting to create</li>
        //         </div>
        //     )
        // },
        // {
        //     date: "Oct 26th, 2025",
        //     content: (
        //         <div className="space-y-4">
        //             <h3>✨ New Features</h3>
        //             <li>   The Portal now supports multi-tab browsing!</li>
        //             <ul> You can right-click on a Site ID, Portal tab or Lock ID to open it in a new browser tab for easier multitasking</ul>
        //             <li> Added ability to mass update Padlock owners from the Padlocks tab</li>
        //             <li> Added ability to export Padlocks & Keyboxes to an excel file</li>
        //             <br></br>
        //             <h3>🛠️ Improvements</h3>
        //             <li>   Added clickable link to Lock ID on Devices page, for easier navigation to Padlock page.</li>
        //             <li>   Added new search & filtering options to Padlocks & Keyboxes page.</li>
        //             <li>   Resolved layout issues on the Rules page for better display on smaller screens.</li>
        //             <li>   Resolved layout issues with the Side nav bar for easier navigation on smaller screens</li>
        //             <li>   Resolved layout issues with the Padlocks/Keyboxes/Sensors/Gateways lists on smaller screens</li>
        //             <li>   Added IP Address/Site Type to user sites list</li>
        //             <br></br>
        //             <h3>🐞 Fixes</h3>
        //             <li>    Fixed an issue preventing passcode creation on Padlocks.</li>
        //             <li>    Fixed a bug where bookmarking the Portal could cause it to crash on launch.</li>
        //         </div>
        //     )
        // },
        // {
        //     date: "Nov 17th, 2025",
        //     content: (
        //         <div className="space-y-4">
        //             <h3>✨ New Features</h3>
        //             <li>   Added the ability to edit schedules from the <em>Scheduled sites</em> page!</li>
        //             <ul> Simply click on an Arm or Disarm schedule to edit the execution time & days</ul>
        //             <li> Added 'Last update' date to edited schedules to easily keep track of which have been modified already</li>
        //             <li>   Added new <em>Live view enabled</em> page!</li>
        //             <ul> Easily view sites with cameras linked, as well as when they were linked & by whom!</ul>
        //             <li> Added Inniovate only Live View switch to allow setting of Live View licence per site</li>
        //             <br></br>
        //             <h3>🛠️ Improvements</h3>
        //             <li>   Greyed out inactive sites on site lists to easily distinguish those that are active</li>
        //             <li>   Changed app view icon to 'Settings cog' instead of Pencil</li>
        //             <li>   Resolved layout issues on the Rules page for better display on smaller screens.</li>
        //             <li>   Added linked camera count to Overview page of Live View enabled sites</li>
        //             <li>   Added Live View stats to Dashboard & Group Dashboards - count of Live View enabled sites & no. of cameras linked</li>
        //             <li>   Added camera & site counts to new <em>Live view enabled</em> page</li>
        //             <li>   Updated <em>Scheduled sites</em> page to allow filtering by day of execution</li>
        //             <li>   Changed 'Holiday mode' to 'Temporary Schedules' throughout</li>
        //             <br></br>
        //             <h3>🐞 Fixes</h3>
        //             <li>    Fixed an issue with selecting page size on site event logs.</li>
        //             <li>    Fixed an issue where G2CC sites showed as 'Physical Controller' on Overview page</li>
        //             <li>    Fixed an issue where some duration codes didn't display the end date & which pin type was created</li>
        //             <li>    Fixed issue with Portal name not updating on App UI after 1st change</li>
        //             <li>    Fixed issue with Reminders showing as a Schedule</li>
        //             <li>    Fixed issue with create mass/individual temporary schedule</li>
        //         </div>
        //     )
        // },
        // {
        //     date: "Nov 25th, 2025",
        //     content: (
        //         <div className="space-y-4">
        //              <h3>✨ New Features</h3>
        //             <li>   Ganz AiBox V2 is here!</li>
        //             <ul> You can now control your Ganz AiBox Channels, Rules, Relays or the whole Hub!</ul>
        //             <li>   Added new 'Give Portal access' button to the header bar to easily grant access to the Portal</li>
        //             <br></br>
        //             <h3>🛠️ Improvements</h3>
        //             <li>   Completely reworked Active Sites, Inactive Sites, Controllers & Sites on schedule to reduce load times and increase responsiveness</li>
        //             <li>   Updated 'Add to group' dropdown menus. They're now searchable with an improved UI</li>
        //             <li>   Account username & email address is now displayed in the header bar</li>
        //             <li>   Reworked Live view enabled page to be site orientated</li>
        //             <li>   Added ability to click on 'Camera count' on Live view sites to show list of linked cameras</li>
        //             <li>   Redesigned Devices & Rules layouts due to rendering issues</li>
        //             <br></br>
        //             <h3>🐞 Fixes</h3>
        //             <li>    Fixed an issue with incorrect error messages being shown when inviting a user</li>
        //             <li>    Fixed an issue with searching on the Active & Inactive sites tab</li>
        //            <li>     Fixed an issue with duplicate schedules appearing after creating a 'Temporary schedule'</li>
        //         </div>
        //     )
        // },
        // {
        //     date: "Dec 17th, 2025",
        //     content: (
        //         <div className="space-y-4">
        //              <h3>✨ New Features</h3>
        //             <li> Super Rules are here!</li>
        //             <ul> You can now create rules to affect other sites, perform different actions on outputs & choose days of the week or hours of the day on which the rule executes! You can also click on a Super Rule to view it or add/remove actions</ul>
        //             <li> New search features on <em>All Sites</em> & <em>Group sites</em></li>
        //             <ul> You can now deep dive into sites, filter by linked devices, Group, schedules, live view status & much more! Click on the filter icon on the search bar to get started</ul>
        //             <li> Temporary users!</li>
        //             <ul> You can now add access expiry dates to user invites, so they will be automatically removed when the time comes</ul>
        //             <li> Hikvision!</li>
        //             <ul> You can now add/remove Hikvision devices from G2CC sites</ul>
        //             <li> Live View!</li>
        //             <ul> You can now add/remove Live View cameras to Live View enabled sites</ul>
        //             <ul> </ul>

        //             <br></br>
        //             <h3>🛠️ Improvements</h3>
        //             <li> Search & filter options are now stored when you enter/exit a site on <em>All Sites</em> page</li>
        //             <li> Number of linked cameras is now displayed on the 'All Sites' list</li>
        //             <li> Redevelopment of the Group sites page, to massively decrease load times & added the new advanced filtering options</li>
        //             <li> S/O is displayed on the 'All Sites' list for sites that are 'Schedule Only'</li>
        //             <li> Redeveloped the 'Create Group' feature to be more responsive</li>
        //             <li> Tidyied up filter dropdowns throughout Portal</li>
        //             <li> Improved the Group selection dropdown throughout, to be more responsive & searchable</li>

        //             <br></br>
        //             <h3>🐞 Fixes</h3>
        //             <li> Fixed an issue with users not being displayed when viewing a groups Portal users</li>
        //             <li> Fixed an issue with refreshing the page while viewing a group's sites causing the site to crash</li>
        //             <li> Fixed an issue with opening a site which had 0 active switches</li>
        //             <li> Fixed loading issue on Devices page when a Ganz AIBox was linked</li>

        //         </div>
        //     )
        // },
//         {
//             date: "Jan 26th, 2026",
//             content: (
//                 <div className="space-y-4">
//                     <h3>✨ New Features</h3>
//                     <li>CCTV Status!</li>
//                     <ul>Added new 'traffic light' indicators to CCTV systems. When a 3rd party device linked to a G2CC site is unreachable for 10 minutes its status will become yellow, if it's still not reachable after 20 minutes it becomes amber, 30 or more minutes it becomes red.</ul>
//                     <ul>Easily find problematic sites by applying the new 'Only show CCTV systems with connection issues' filter on both <em>All sites</em> & <em>3rd party CCTV</em> tabs </ul>
//                     <ul>Output status icons will now reflect CCTV connection status. if unstable, the warning icon will replace the output status on site lists</ul>
//                     <li> AJAX! </li>
//                     <ul> Added ability to link AJAX devices on Portal</ul>
//                     <li> Dahua!</li>
//                     <ul> Added ability to add Dahua devices on Portal </ul>
//                     <li> Site location & type</li>
//                     <ul> Added ability to set a sites location & type, these can then be used as filters on the <em>Scheduled sites</em> & <em>Temporary schedules</em> pages, for easier management of schedules</ul>
                    

//                     <br></br>
//                     <h3>🛠️ Improvements</h3>
//                     <li> Mass upload options now have template .csv files available to download</li>
//                     <li> Redesigned 'Mass create user' & 'Mass invite user' pop-ups to be more informative when the process is executing.</li>
//                     <li> Added the ability to 'Mass invite users' from within the site on the <em>Users</em> tab</li>
//                     <li> Added ability to change a users role to 'Manager plus' using the settings cog as well as the mass action dropdown menu </li>
//                     <li> Changed default <em>Users</em> page size to 50 & increased page size options to 20, 50, 100</li>
//                     <li> Added pencil icon to items that are editable on <em>Overview</em> page & <em>Users</em> tab</li>
//                     <li> Added 'Controlled by' & 'Controlling' hyperlinks to sites which use new Super rules, for easier naviagtion between Parent & Child sites</li>
//                     <li> Updated Super rule UI on <em>Devices</em> page to show which site is being controlled by the rule</li>
//                     <li> Super rules are now displayed on both Parent & Child sites for better understanding of whats affecting the site</li>
//                     <li> Added new filter to only show 'Live view enabled' sites that either have or don't have a camera linked</li>
//                     <br></br>
//                     <h3>🐞 Fixes</h3>
//                     <li> Fixed an issue with 'Viewable by standard user' switch showing the incorrect status when editing an output</li>
//                     <li> Fixed an issue with both 'LATCH' & 'PULSE' showing as selected when editing an output</li>
//                     <li> Fixed an issue with readability on registration forms</li>
//                     <li> Fixed an issue with inputs 1, 2, 3 & 4 not being availble to link on virtual devices</li>
//                 </div>
//             )
//         },
//          {
//             date: "March 30th, 2026",
//             content: (
//                 <div className="space-y-4">
//                     <br></br>
//                     <h3>🛠️ Improvements</h3>
//                     <li> Redesigned Gateway, Padlock & Keybox battery & signal indicators on lists & 'Devices' tiles</li>
//                     <li> Changed 'Last updated' text to red, for easier identification of problem Gateways</li>
//                     <li> Added 'Last updated' date to Padlocks & Keyboxes, for clearer representation of battery levels</li>
//                     <li> Added 'Counts' such as 'Low battery/Daily poll missed' to Gateways, Padlocks & Keyboxes tab, for easier identification of issues</li>
//                     <li> Updated App UI to only show active outputs & inputs</li>
//                     <li> Added new filtering options to Gateways, you can now filter by battery level, signal strength & more</li>
//                     <li> Redesigned popups & buttons throughout Portal</li>
//                     <li> Updated loading animations of Dashboard, Rules, Devices & Logs</li>
//                     <li> Added confirmation of success/failure popups to various actions throughout Portal</li>
//                     <li> Added hyperlink to users in Site users tab & Site event logs, to allow quick viewing of the users profile</li>
//                     <li> Added new 'Refresh' button to site event logs & removed caching - logs will now reload each time the tab is opened</li>
//                     <li> Added ability grant admin access to a user while creating their account</li>

//                     <br></br>


//                     <h3>🐞 Fixes</h3>
//                     <li> Fixed an issue with 'Create Portal User' form showing white text on a white background'</li>
//                     <li> Fixed an issue with exporting event logs showing irrelevant data</li>
//                     <li> Fixed an issue with editing time values when creating/editing Schedules & Reminders</li>
//                     <li> Fixed an issue allowing temporary schedule start date to be after end date</li>
//                     <li> Fixed sizing issue with the Reset filters button on Group sites & All Sites</li>
//                     <li> Fixed sizing issue with the 'Collapse App View' button</li>
//                     <li> Fixed layout issue with the site name on App View overlapping the Site ID</li>
//                     <li> Fixed an issue with exporting users to excel, only exporting the first 10</li>
//                     <li> Fixed loading issue with Rules tab causing flickering/stuttering</li>
//                     <li> Fixed an issue with 'Controlling ...' & 'Controlled by...' text staying above App View after deleting the Rule</li>
//                     <li> Fixed an issue with creating more than 1 'Site access restriction'</li>
//                     <li> Fixed an issue with deleting more than 1 Rule (new) </li>
//                     <li> Fixed issue with pop-up size when viewing a Camect camera list</li>
//                     <li> Fixed an issue with the Control Bar within a Site getting cut off when window size is reduced</li>
//                 </div>
//             )
//         },
//         {
//              date: "April 10th, 2026",
//             content: (
//                 <div className="space-y-4">
//                     <h3>✨ New Features</h3>
//                     {/* <li><strong>Site Analytics</strong></li>
//                     <ul>Introduced a new analytics section when viewing a site, providing deeper insights across three dedicated tabs: <em>User Analytics</em>, <em>Schedules</em>, and <em>Security</em>.</ul>
//                     <li><strong>User Analytics:</strong>  
//                         <ul className="list-disc pl-5">
//                             <li>View activity based on selected output pin (with or without padlocks).</li>
//                             <li>Analyse usage through bar charts, line graphs, and tables.</li>
//                             <li>Identify top users and overall usage trends.</li>
//                             <li>Filter data by time period (year, month, week).</li>
//                             <li>Click users to open their individual pages and inspect logs.</li>
//                         </ul>
//                     </li>

//                     <li><strong>Schedule Insights:</strong>  
//                         <ul className="list-disc pl-5">
//                             <li>Understand how effective your site schedules are.</li>
//                             <li>View schedule failures using bar charts.</li>
//                             <li>Track success rates with a doughnut chart.</li>
//                             <li>Filter data by time period (year, month, week).</li>
//                         </ul>
//                     </li>

//                     <li><strong>Security Monitoring:</strong>  
//                         <ul className="list-disc pl-5">
//                             <li>Monitor potential security concerns across your site.</li>
//                             <li>Track invalid padlock PIN entries, gateway tampering, and forced padlock openings.</li>
//                             <li>Visualised in a line graph for trend analysis.</li>
//                         </ul>
//                     </li> */}

//                     <li><strong>User Activity:</strong>  
//                         <ul className="list-disc pl-5">
//                             <li><em>Users</em> tab has been split into 2 sub-tabs</li>
//                             <li>View a list of all sites a user has access to</li>
//                             <li>View a log of the users activity across their sites</li>
//                         </ul>
//                     </li>

//                     <li><strong>Live View:</strong>  
//                         <ul className="list-disc pl-5">
//                             <li>The <em>Live View</em> tab has now been split into 2 sub-tabs!</li>
//                             <li>View a list of all your Live View enabled sites that have a camera linked</li>
//                             <li>View a list of all your linked Live View Cameras & their associated sites</li>
//                             <li>Added ability to mass delete live view cameras</li>
//                             <li>Added ability to mass transfer live view cameras</li>
//                         </ul>
//                     </li>

//                     <br></br>
                
//                     <h3>🛠️ Improvements</h3>
//                    <li>Added a search bar to Live View sites </li>
//                    <li>Updated Site 'Events' UI </li>
//                    <li>Added ability to view linked BLE Sensors in the 'Devices' tab</li>
//                     <br></br>

//                     <h3>🐞 Fixes</h3>
//                     <li>Fixed an issue where a users account failed to display who invited them to the system</li>
//                     <li>Fixed an issue with exporting users only exporting the first 10</li>

//                 </div>
//             )
//         },
//                {
//              date: "April 17th, 2026",
//             content: (
//                 <div className="space-y-4">
//                     <h3>✨ New Features</h3>
//                      <li><strong>Redesigned dashboard!</strong>  
//                         <ul className="list-disc pl-5">
//                             <li>Dashboard now has real time data showing the status of your connected devices</li>
//                             <li>Easily view Gateway, Padlock & Keybox health</li>
//                         </ul>
//                     </li>
                   
//                     <li><strong>Create site:</strong>  
//                         <ul className="list-disc pl-5">
//                             <li>You can now create a G2CC site and assign it to a group.</li>
//                             <li>To get started click the new settings icon in the top right corner and press 'Create site'</li>
//                         </ul>
//                     </li>

//                     <li><strong>View team:</strong>  
//                         <ul className="list-disc pl-5">
//                             <li>Easily view and control who has access to your Portal group</li>
//                             <li>To get started click the new settings icon in the top right corner and press 'Team'</li>
//                         </ul>
//                     </li>

//                     <br></br>
                
//                     <h3>🛠️ Improvements</h3>
//                    <li>Added Site ID and Portal name to all tabs in Site view when the App view is collapsed</li>
//                     <li>Added ability to filter by CCTV connection in <em>Scheduled sites</em></li>
//                    <li>Added ability to set 'Powered by' when linking a gateway</li>
//                    <li>Added new 'BLE Sensor' option to <em>All Sites</em> filters</li>
//                     <br></br>

//                     <h3>🐞 Fixes</h3>
//                     <li>Fixed random '0' appearing below site name in App View when a Gateway is linked</li>
//                     <li>Fixed 'Sort by last seen' options not applying correctly in Gateways</li>

//                 </div>
//             )
//         },
//         {
//              date: "May 28th, 2026",
//             content: (
//                 <div className="space-y-4">
//                     <h3>✨ New Features</h3>
//                      <li><strong>User levels</strong>  
//                         <ul className="list-disc pl-5">
//                             <li>There are now 3 user levels in Portal. <em>Admin</em>,<em> Manager</em> & <em>Operator</em></li>
//                             <li>Each role has </li>
//                         </ul>
//                     </li>
                   
//                     <li><strong>Customise table views</strong>  
//                         <ul className="list-disc pl-5">
//                             <li>You can now hide or show columns on the site lists & more!</li>
//                             <li>To get started click the new icon in the top right corner of site lists</li>
//                         </ul>
//                     </li>

//                     <li><strong>Group permissions</strong>  
//                         <ul className="list-disc pl-5">
//                             <li>When creating a group, you can now control some of the Portal features the group has access to</li>
//                         </ul>
//                     </li>

//                     <li><strong>Dashboard</strong>  
//                         <ul className="list-disc pl-5">
//                             <li>Redesigned Dashboard to give real-time overview of your portfolio & linked devices</li>
//                             <li>Dashboard now shows number of CCTV devices offline, click on these tiles to quicky see which devices have issues!</li>
//                         </ul>
//                     </li>

//                     <li><strong>Analytics</strong>  
//                         <ul className="list-disc pl-5">
//                             <li><em>User analytics</em> are now available in the Group Overview tab and the User Analytics tab, featuring insights into top performing users</li>
//                             <li>All users within a chosen group are now viewable at a glance in the All Users tab</li>
//                             <li></li>
//                             <li><em>Site analytics</em> are now available to view top performing users for each switch on each site</li>
//                         </ul>
//                     </li>



//                     <br></br>
                
//                     <h3>🛠️ Improvements</h3>
//                    <li>Added ability to search by Site ID or Portal name when copying users to a new site</li>
//                    <li>Added ability to search by Site ID when linking 2 sites together via a Rule</li>
//                    <li>When creating Rules, a summary will show in the bottom corner displaying what has been selected so far as you progress through the steps</li>
//                     <li>Added ability to email a user when clicking on their email address in the Users tab</li>
//                     <li>Added new column to <em>3rd Party CCTV</em> tab showing date & time it went offline</li>
//                     <li>Added new 'Connection stability' column to devices on <em>3rd Party CCTV tab</em> to give a better indication of its overall health</li>
//                     <li>Added quick filter buttons to <em>3rd Party CCTV</em> tab, to quickly find problematic sites </li>
//                     <li>Added ability to unlink BLE/Standalone NB-IoT sensors</li>
       
//                     <br></br>

//                     <h3>🐞 Fixes</h3>
//                     <li>Removed 'End date' for Permanent passcodes</li>
//                     <li>Fixed issue with Gateway events not displaying correctly</li>
//                 </div>
//             )
//         },
//         {
//             date: "June 12th, 2026",
//             content: (
//                 <div className="space-y-4">
//                     <h3>✨ New Features</h3>
//                      <li><strong>Schedule analytics!</strong>  
//                         <ul className="list-disc pl-5">
//                             <li>You can now view which sites have frequently failing arm/disarm schedules in the <em>Scheduled sites</em> tab</li>
//                         </ul>
//                     </li>
            
//                     <br></br>
                
//                     <h3>🛠️ Improvements</h3>
//                    <li>Added switch to choose between your group only and full portfolio on Dashboard</li>
//                    <li>Redeveloped Dashboard for more accurate counts</li>
//                    <li>Added Camect to CCTV integrations tab</li>
//                     <li>Added Camect counts to Dashboards</li>
//                     <li>Added new Hik integration for channel selection</li>
//                     <li>Added offline counts to 'Connection stability analytics' tab of 3rd party cctv </li>
//                     <li>Changed Parent/Child sites to display portal name instead of Site ID when displaying links</li>
//                     <li>Added outline to iONs on site lists & app view for easier identification</li>
//                     <li>Refreshed AppView UI to use matching mobile app icons & display action text</li>
//                     <li>Made 'pulse' outputs easier to Identify on AppView UI</li>
//                     <li>Updated 'Gateway' UI on AppView - now shows date/time of last update and current status</li>
//                     <li>Updated Rule UI on <em>Devices</em> tab - now shows trigger & actions without having to click into the rule</li>


//                     <br></br>

//                     <h3>🐞 Fixes</h3>
//                     <li>Fixed issue with activating a site after setting the portal name</li>
//                     <li>Fixed an issue with portal name not being used when inviting users if it was just set</li>
//                     <li>Fixed crash when navigating to a group by clicking on the name in site lists</li>
//                     <li>Fixed an issue with rules showing incorrect arm/disarm time when created using mobile app</li>
//                     <li>Fixed an issue with pulse length not showing when editing the output</li>
//                     <li>Fixed an issue with Create User form showing white text on a white background</li>
//                     <li>Fixed an issue where changing output type would create a rule using old type</li>
                 
//                 </div>
//             )

//         },
//         {
//             date: "June 24th, 2026",
//             content: (
//                 <div className="space-y-4">
//                     <h3>✨ New Features</h3>
//                      <li><strong>Sequential Rules</strong>  
//                         <ul className="list-disc pl-5">
//                             <li>A sequential rule is created by having 1 or more 'conditions' in a rule. When adding the 2nd condition select 'Yes, order matters' to enable. This means the rule becomes 'If this AND THEN that - perform action'</li>
//                         </ul>
//                     </li>

//                     <li><strong>Snapshot Rules</strong>  
//                         <ul className="list-disc pl-5">
//                             <li>When chosing what a Rule does, you can now select 'Take snapshot' - this will return a list of snapshot enabled cameras currently linked to the site. Choose the camera(s) you want to take a snapshot and an image notification will be sent to the app (app update pending) when the rule executes</li>
//                             <li>Snapshots can also be viewed in the <em>Event logs</em></li>
//                         </ul>
//                     </li>

//                     <li><strong>Analytics</strong>  
//                         <ul className="list-disc pl-5">
//                             <li>Aggregated analytics are now available for individual sites which allow you to see an overview of total actions, padlock unlocks, schedule failures & top users at a glance.</li>
//                         </ul>
//                     </li>
            
//                     <br></br>
                
//                     <h3>🛠️ Improvements</h3>
//                    <li>Added ability to create user from header menu dropdown</li>
//                     <li>Updated group selection dropdown UI when adding a user to sites via their profile</li>
//                     <li>Added tooltips to Stat cards on Dashboards for better clarity on what the counts represent</li>
//                     <li><em>All Sites</em> tab is now order by the date a site was made active by default</li>
//                     <li>Added ability to edit SMTP details in Overview page</li>
// <br/>
//                     <h3>🐞 Fixes</h3>
//                     <li>Fixed issue with having special characters or empty as Portal site name</li>
//                     <li>Removed ability to add as 'App manager plus' when live view is not enabled for site</li>
//                     <li>Fixed issue with pulse timer not showing when editing a pulse pin</li>
//                     <li>Fixed issue where you could change a latch to a pulse without setting a length</li>
//                     <li>Fixed bug with auto-logout redirecting new users to portal login when attempting to register</li>
//                     <li>Fixed issue with 'Load more' button showing when all data is loaded on schedule tabs</li>
//                     <li>Fixed issue with changing role to 'Manager' for Portal access not working</li>
//                     <li>Fixed issue with time/day restricted rules not working</li>
//                     <li>Fixed issue with Rule options showing as inverted</li>
//                     <li>Fixed issue with setting Gateway name</li>
//                 </div>
//             )
//         },
//           {
//             date: "July 16th, 2026",
//             content: (
//                 <div className="space-y-4">    
//                     <h3>✨ New Features</h3>
//                     <li><strong>Mass arm/disarm CCTV</strong>  
//                         <ul className="list-disc pl-5">
//                             <li>You can now mass arm/disarm CCTV devices in the <em>3rd Party CCTV</em> tab! Select sites using the checkboxes on the left & choose Arm or Disarm from the dropdown menu</li>
//                         </ul>
//                     </li>
//                     <h3>🛠️ Improvements</h3>
//                    <li><em>App View</em>,<em>All Sites</em>, <em>3rd Party CCTV</em> tabs now use live states for output/input icons</li>
//                     <li><em>3rd Party CCTV</em> tab now has 'last action' time & date</li>
//                     <li>Added ability to mass update 'Site Type' & Site Location' on <em>All Sites</em> tab</li>
//                     <li>Added ability to filter by 'Site Type' & 'Site Location' on <em>3rd Party CCTV</em> tab</li>
//                     <li>Added ability to sort by 'Date made active' 'Portal name' and 'App name' on <em>3rd Party CCTV</em> tab</li>
//                     <li>Added ability to customise <em>3rd Party CCTV</em>  table columns</li>
//                     <li>Added ability to make an output 'Admin only' 'Manager only' or 'Any'</li>
//                     <li>Added ability to enable/disable temp actions for an output</li>
//                     <li>Added ability to restrict 'App Standard Users' to temp actions only</li>
//                     <br/>
//                     <h3>🐞 Fixes</h3>
//                    <li>Fixed issue where applied filters would reset when entering/exiting a site in <em>3rd Party CCTV</em></li>
//                    <li>Fixed an issue where sites moved to newly created groups could not be made active</li>
//                 </div>
//             )
//         },
//         {
//             date: "July 29th, 2026",
//             content: (
//                 <div className="space-y-4">    
//                     <h3>✨ New Features</h3>
//                     <li><strong>Analytics timeframes</strong>  
//                         <ul className="list-disc pl-5">
//                             <li>You can now choose a custom timeframe on all analytics</li>
//                         </ul>
//                     </li>
//                     <h3>🛠️ Improvements</h3>
//                    <li>You can now filter by 'Site type' on Schedule analytics</li>
//                     <li>You can now export the Group user list to an excel file</li>
//                     <li>You can now export Padlock analytics as a .pdf</li>
//                     <li>You can now view schedule failures on a per site basis</li>
//                     <li>You can now edit existing CCTV integrations, such as updating selected channels or events to control</li>
//                     <li>You can now edit Live View Camera URLs</li>
//                     <li>Added ability to copy user email address when clicking on their email</li>
//                     <li>Added ability to set a site to active while setting its Portal name</li>
//                     <li>Changed CCTV Integration login so it no longer forces you to re-enter all details after a failed login</li>
//                     <li>Added new Dahua integration to allow specific channel selection</li>
//                     <li>Added 'admin only' icon to outputs</li>
//                     <li>Added ability to view a groups subgroups</li>
//                     <li>Added ability to click on group hierarchies to navigate to that group</li>
//                     <li>Added ability to select multiple integrations in 3rd Party CCTV tab filters</li>
//                     <br/>
//                     <h3>🐞 Fixes</h3>
//                    <li>Fixed issue with checkbox and dropdown menu being nearly invisible on inactive/suspended sites in lists</li>
//                    <li>Fixed an issue where sites moved to newly created groups could not be made active</li>
//                    <li>Fixed issue with linking sensors to inputs 1,2,3,4 on iONs</li>
//                    <li>Fixed an issue with editing Camect addresses causing each keystoke to move to end of the address</li>
//                    <li>Fixed issue with 'Temp actions' showing as an option in edit pin on Inputs, Pulses and Padlocks</li>
//                    <li>Fixed issue with 'Date made active' not showing as an option when sorting 'All sites'</li>
//                 </div>
//             )
//         },
        {
            date: "August 17th, 2026",
            content: (
                <div className="space-y-4">    
                    <h3>✨ New Features</h3>
                    <li><strong>Gateway Analytics!</strong>  
                        <ul className="list-disc pl-5">
                            <li>You can now view your battery and signal analytics for Gateways</li>
                        </ul>
                    </li>
                    <li><strong>Schedule Success Rates</strong>  
                        <ul className="list-disc pl-5">
                            <li>You can now view your estimated schedule success rates for sites and groups</li>
                        </ul>
                    </li>
                     <li><strong>NB-IoT & BLE Sensors</strong>  
                        <ul className="list-disc pl-5">
                            <li>You can now aadd NB-IoT & BLE Sensors via Portal using the 'Devices' tab</li>
                        </ul>
                    </li>
                     <li><strong>ARC Notifications</strong>  
                        <ul className="list-disc pl-5">
                            <li>When sending an alert using a rule, you now have the option to send the alert to the monitoring arc too</li>
                        </ul>
                    </li>
                    <br/>
                    <h3>🛠️ Improvements</h3>
                    <li>Added more detail to the 'Create Rule' wizard, you can now view each step as its being created, as well as a full summary at the end</li>
                    <li>Added more detail to the 'CCTV Integration' tiles on the 'Devices' tab to show what is being controlled</li>
                    <li>Added a banner to sites when a temporary schedule is active</li>
                    <li>Added a popup warning when actioning on a site that has an active temporary schedule</li>
                    <li>Added 'CCTV Integration' icons to outputs on the App View, to show which output is controlling which integration</li>
                    <li>Added ability to hide/show table columns on 'Groups' table</li>
                    <li>Added ability to filter groups</li>
                    <li>Added branding logo & site name to padlock usage PDF</li>


                    <br/>
                    <h3>🐞 Fixes</h3>
                   <li>Fixed issue with creating snapshot rules for Hikvision devices</li>
                   <li>Fixed an issue with creating 'Smart Reminders' for inputs</li>
                    <li>Fixed an issue where some mass actions were not available for Portal users</li> 
                </div>
            )
        },
        {
            date: "October 2nd, 2026",
            content: (
                <div className="space-y-4">    
                    <h3>✨ New Features</h3>
                    <li><strong>App View Updated Functionality!</strong>  
                        <ul className="list-disc pl-5">
                            <li>You can now <i>view/create passcodes, view upcoming schedules, amend schedules & temporarily arm/disarm</i> directly in the App View</li>
                        </ul>
                    </li>
                    
                    <br/>

                    <h3>🛠️ Improvements</h3>
                    <li>Updated the pin view UI to closely resemble the mobile apps design</li>
                    <li>Added a new card in the pin view to alert users when a padlock has been left open</li>
                    <li>Added the ability to apply visibility changes across multiple pins at once</li>
                    <li>Added output and input numbers to the pin editing view</li>
                    <li>Events chart now include days with zero activity, giving a complete timeline</li>
                    <li>All charts can now be exported as PDFs</li>
                    <li>Updated Ganz AIBOX setup wizard</li>
                    <br/>

                    <h3>🐞 Fixes</h3>
                   <li>Fixed an issue where admin & manager icons weren't displaying on pulse pins</li>
                   <li>Fixed a bug where an unexpected sort chip appeared under search bars</li>
                   <li>Fixed issue with selecting outputs when creating a schedule</li>
                   <li>Fixed issue with reset site feature not allowing group selection & crashing</li>
                   <li>Fixed issue with 'Sequential' not being a rule option for Gateway triggered rules</li>
                   <li>Fixed issue with arm/disarm error messages being shown even when you have left the site</li>
                   <li>Removed ability to upload a csv of users when more than 1 site is selected</li>
                   <li>Fixed issue with only 1 output name being shown when creating/editing a schedule/reminder</li>
                   <li>Fixed issue with temp rule actions time length being shown in seconds</li>
                   <li>Fixed issue with adding a padlock sometimes getting stuck on the 'Enter ID' popup</li>
                   <li>Fixed issue with long portal names causing AppView to stretch when its a parent/child site</li>
                </div>
            )
        },
        {
            date: "October 8th, 2026",
            content: (
                <div className="space-y-4">    

                    <h3>🛠️ Improvements</h3>
                    <li>Switching off pin visibility now automatically disables its notifications</li>
                    <li>Padlocks are now still available in offline sites</li>
                    <li>Pre-access toggle now available in settings for padlocks</li>
                    <li>Redesigned the 'padlock left open' card in the pin view to emphasise open alerts</li>
                    <li>Padlock <i>'Open Duration History'</i> table now defaults to sort by total opens</li>
                    <br/>

                    <h3>🐞 Fixes</h3>
                    <li>Fixed a bug where multi-selecting pins to be visible/hidden would unexpectedly affect unselected pins</li>
                    <li>Fixed a bug where the pin view UI on a site with zero visible pins would break</li>
                    <li>Fixed a bug where pulses were still clickable during an ongoing pulse</li>
                    <li>Fixed a bug where certain settings that weren't intended to be available for padlocks & pulses were available</li>
                    <li>Fixed a bug where the action button on pulse pins were always "Disarm". Now utilises <i>'Pulse Action Button'</i> descriptor set in settings.</li>
                    <li>Fixed a bug where hovering over a site with an access restriction would display 'User account suspended'</li>
                    <li>Fixed a bug where the 'Cancel temporary (action)?' pop up when interrupting a temporary action had a mismatch in the action type</li>
                </div>
            )
        },
        {
            date: "October 23rd, 2026",
            content: (
                <div className="space-y-4">    
                    <h3>✨ New Features</h3>
                    {showCamect && (
                        <li><strong>Camect Wizard</strong>
                            <ul className="list-disc pl-5">
                                <li>Adding Camects has been completely redesigned. You can now add, test & link a Camect all in 1 set-up wizard!</li>
                            </ul>
                        </li>
                    )}
                    <li><strong>Hikvision Wizard</strong>  
                        <ul className="list-disc pl-5">
                            <li>Linking a Hikvision device has been completely redesigned. The set-up process now uses a wizard to allow access to even more Hikvision features!</li>
                        </ul>
                    </li>

                    <li><strong>Gateway alert toggle</strong>  
                        <ul className="list-disc pl-5">
                            <li>You can now disable Gateway low battery emails using the 'Gateway battery alerts' tile in the <em>Overview</em> page of a site.</li>
                        </ul>
                    </li>

                     <li><strong>Global site search</strong>  
                        <ul className="list-disc pl-5">
                            <li>There is now a search bar at the top of Portal to allow searching for a site from anywhere!</li>
                        </ul>
                    </li>
                
                    <br/>


                    <h3>🛠️ Improvements</h3>
                    {showCamect && <li>You can now filter <em>All sites</em> by site type: Camect</li>}
                    {showCamect && <li>Camect icons now appear on outputs that have a Camect linked</li>}
                    <li>User search now has filters for user type: "portal admin" & "app admin"</li>
                    {showCamect && <li>Camect cameras can now be added as live view cameras</li>}
                    {/* {showCamect && <li>Added new Camect failure messages & icons to the site logs</li>} */}
                    <li>Added a 'States' column to a user's site list</li>
                    <li>Clearer error messages when adding a Portal user that already exists</li>
                    <li>Updated the success & error pop-ups on the site page to the new dialog design</li>
                    <br/>

                    <h3>🐞 Fixes</h3>
                    <li>Fixed a bug where the name of the user that linked a live view camera was showing up as an ID</li>
                    <li>Fixed a bug where a padlock was being shown as 'Open' when the Gateway was offline</li>
                    <li>Fixed a bug where Padlocks that were not linked to a site could not be viewed in the <em>Padlocks</em> tab</li>
                    <li>Fixed a bug where the Padlocks, Keyboxes & Sensors sections on the Dashboard could be hidden even when you had those devices</li>
                    <li>Fixed a bug where a timeframe was forced when creating rules using 'OR' conditions</li>
                    <li>Fixed a bug where '-deleted' was shown on schedules, rules, access restrictions & linked devices when the user's account had been deleted</li>
                    <li>Fixed a bug where refreshing the logs didn't always show the latest data without a hard refresh</li>
                    <li>Fixed a bug where the site page didn't refresh correctly after clearing the logs</li>
                    <li>Fixed a bug where filtering the users list loaded the data twice</li>

                </div>
            )
        }
    ]

    const [selected, setSelected] = useState(changelogs[3]);

    const HandleUipiodOnClick = (DeviceUUID) => {
        dispatch(serviceActions.setDeviceUUID(DeviceUUID));
        useSetCookie("DeviceUUID", DeviceUUID, 1);
        navigate("/Dashboard/SiteView/" + DeviceUUID);
    }

    const HandleNext = () => {
        setGroupID(selectedGroup.id)
        setAddUserStep1Visible(false)
        setAddUserStep2Visible(true)
    }

    const HandleNextCreateSite= async () => {
        setCreateSiteStep1Visible(false)
        const response = await createSite(apiData, createSiteForGroup.name, createSiteForGroup.id, userID, dispatch)
        if (response.success){
            setCreateSiteSuccessVisible(true)
            setNewSiteUUID(response.data[0] ?? "")
        } else {
            setCreateSiteFailVisible(true)
        }
    }

    const GoToSite = () => {
        setCreateSiteSuccessVisible(false)
        dispatch(serviceActions.setDeviceUUID(newSiteUUID));
        useSetCookie("DeviceUUID", newSiteUUID, 1);
        navigate("/Dashboard/SiteView/" + newSiteUUID);
    
        //reload?
    }

    const HandleCreateUser = () => {
        setShowSettingsMenu(false)
        setAddUserStep2Visible(false)
        setFailVisible(false)
        setCreateUserVisible(true)
        setShowAddUserFail(false)
    }

    const HandleCreateSingleUser = () => {
        setCreateSingleUserVisible(true)
    }

    const HandleNavigateToTeam = async () => {
        setShowSettingsMenu(false)
        const allGroups = JSON.parse(localStorage.getItem('groups') || '[]')
        const companyGroup = allGroups.find(g => g.name === companyName)
        if (!companyGroup) return
        setPortalUsersVisible(true)
        setPortalUsersLoading(true)
        try {
            const response = await getGroupUsers(apiData, companyGroup.id, dispatch)
            setPortalUsers(response?.data ?? [])
        } catch {
            setPortalUsers([])
        } finally {
            setPortalUsersLoading(false)
        }
    }

    const HandleViewAccount = () => {
        setShowSettingsMenu(false)
        dataManager.setItem('clickedUserID', userID)
        dataManager.setItem('clickedUserEmailAddress', userEmail)
        localStorage.setItem('ClickedUserFullName', userName)
        localStorage.setItem('clickedUserID', userID)
        dispatch(authActions.setClickedUserDetails({ userID, fullName: userName }))
        navigate('/Dashboard/Users/UserSites')
    }

    const HandleSettingsGivePortalAccess = () => {
        setShowSettingsMenu(false)
        HandleChooseGroup()
    }

    const HandleSettingsCreateGroup = () => {
        setShowSettingsMenu(false)
        setIsCreateGroupVisible(true)
    }

    const HandlePurchaseCCTVLicence = () => {
        setShowSettingsMenu(false)
        setIsDemoCCTVLicenceGrant(false)
        setShowCCTVPurchase(true)
    }

    const resetCreateGroupForm = () => {
        setCreateGroupName('')
        setCreateGroupParent(null)
        setCreateGroupMonitoringStation(null)
        setNewGroupSupportEnabled(false)
        setNewGroupAllowSiteCreation(false)
        setNewGroupBillingEnabled(false)
        setNewGroupAllowGroupCreation(false)
        setNewGroupIsOnDD(false)
        setNewGroupIsBillableAccount(false)
        setNewGroupIsWhitelabel(false)
        setNewGroupUserInvitesEnabled(false)
        setNewGroupCCTVLicensingEnabled(false)
    }

    const handleCreateGroup = async () => {
        if (!createGroupName || !createGroupParent) return
        const body = {
            groupName: createGroupName,
            parentID: createGroupParent.id,
            defaultMonitoredByID: createGroupMonitoringStation?.id ?? null,
            supportEnabled: newGroupSupportEnabled ? 1 : 0,
            allowSiteCreation: newGroupAllowSiteCreation ? 1 : 0,
            billingEnabled: newGroupBillingEnabled ? 1 : 0,
            allowGroupCreation: newGroupAllowGroupCreation ? 1 : 0,
            isOnDD: newGroupIsOnDD ? 1 : 0,
            isBillableAccount: newGroupIsBillableAccount ? 1 : 0,
            isWhitelabelCustomer: newGroupIsWhitelabel ? 1 : 0,
            userInvitesEnabled: newGroupUserInvitesEnabled ? 1 : 0,
            cctvLicensingEnabled: newGroupCCTVLicensingEnabled ? 1 : 0,
        }

        console.log(body);
        const response = await addGroup(apiData, body, dispatch)
        if (response.success) {
            console.log(response);
            setIsCreateGroupVisible(false)
            setNewGroupObject({
                groupName: response.data[0].group.name,
                groupPath: "",
                groupID: response.data[0].group.id
            })
            resetCreateGroupForm()
            setCreateGroupSuccessVisible(true)
        } else {
            setCreateGroupFailMessage(response.msg)
            setCreateGroupFailVisible(true)
        }
    }

    const HandleSettingsLogout = () => {
        setShowSettingsMenu(false)
        HandleLogout()
    }

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (settingsMenuRef.current && !settingsMenuRef.current.contains(e.target)) {
                setShowSettingsMenu(false)
            }
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [])

    // Other pages (e.g. the "Add CCTV Integration" popup in SiteView, when it finds 0 remaining
    // licences, or GroupSites' "Grant demo CCTV licence" button) trigger this dialog via redux
    // rather than owning a copy of it themselves.
    const showCCTVPurchaseModalTrigger = useSelector(state => state.ui.showCCTVPurchaseModal)
    const cctvPurchaseGroupId = useSelector(state => state.ui.cctvPurchaseGroupId)
    const cctvPurchaseMode = useSelector(state => state.ui.cctvPurchaseMode)
    const [isDemoCCTVLicenceGrant, setIsDemoCCTVLicenceGrant] = useState(false)
    useEffect(() => {
        if (!showCCTVPurchaseModalTrigger) return
        // cctvPurchaseGroupId may arrive as a string (e.g. GroupSites reads its groupID out of
        // sessionStorage) while group.id from getGroups() is numeric - compare loosely.
        setSelectedGroupForLicence(groups.find(g => String(g.id) === String(cctvPurchaseGroupId)) ?? null)
        setIsDemoCCTVLicenceGrant(cctvPurchaseMode === "demo")
        setShowCCTVPurchase(true)
        dispatch(uiActions.closeCCTVPurchaseModal())
    }, [showCCTVPurchaseModalTrigger, cctvPurchaseGroupId, cctvPurchaseMode, groups])

    const translateCompanyName = (companyName) => {
        let displayName = companyName
        switch (companyName) {
            case "EyeSpyFX" :
                displayName = "Inniovate"
            break;
        }

        return displayName
    }

    const navigateToCreatedGroup = async () => {
        const newGroups = await getGroups(apiData, dispatch)
        console.log(newGroups);
        if (newGroups.length > 0) {
            localStorage.setItem('groups', JSON.stringify(newGroups));
            sessionStorage.setItem('groupClicked', newGroupObject.groupName)   
            sessionStorage.setItem('groupPath', newGroupObject.groupPath)
            sessionStorage.setItem('groupClickedID', newGroupObject.groupID)   
            navigate(`/Dashboard/Groups/GroupSites/`)
        }    
    }

    const PurchaseCCTVLicence = async () => {
        const body = {
            groupID: selectedGroupForLicence.id,
            groupName: selectedGroupForLicence.name,
            licenceQuantity: selectedCCTVLicenceQuantity
        }
        console.log(body);
        const response = await purchaseCCTVLicence(apiData, body, dispatch)
        console.log(response);
        setShowCCTVPurchase(false)
        if (response.success){
            //success dialog
            setGenericSuccessMessage("CCTV licences purchased successfully")
            setGenericSuccessVisible(true)
        } else {
            //failed dialog
            setGenericFailMessage("Failed to purchase CCTV licences, please try again later")
            setGenericFailVisible(true)
        }

        setSelectedCCTVLicenceQuantity(0)
        setSelectedGroupForLicence(null)
    }

    const GrantDemoCCTVLicence = async () => {
        const body = {
            groupID: selectedGroupForLicence.id,
            demoLicenceQuantity: selectedCCTVLicenceQuantity
        }
        console.log(body);
        const response = await grantDemoCCTVLicence(apiData, body, dispatch)
        console.log(response);
        setShowCCTVPurchase(false)
        if (response.success){
            setGenericSuccessMessage("Demo CCTV licence granted successfully")
            setGenericSuccessVisible(true)
        } else {
            setGenericFailMessage("Failed to grant demo CCTV licence, please try again later")
            setGenericFailVisible(true)
        }

        setSelectedCCTVLicenceQuantity(0)
        setSelectedGroupForLicence(null)
        setIsDemoCCTVLicenceGrant(false)
    }

    const getSiteKey = () => {
        if (typeof siteSearchTerm === "object" && siteSearchTerm !== null) return siteSearchTerm.key;
        return siteSearchTerm;
    };

    const searchSites = async (event) => {
        const responseData = await PowerSearchAPI({ token, client }, event.query, 50, 1, 0, 0, 0, 0, dispatch);
        const devices = responseData?.[0]?.devices ?? [];
        setSiteSuggestions(devices.map(site => ({ key: site.key, tag: site.tag, uuid: site.uuid })));
    };

    const siteItemTemplate = (item) => (
        <div style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center" }}>
            <span style={{ fontWeight: 600 }}>{item.key}</span>
            {item.tag && <span style={{ color: "#6c757d", fontSize: "13px" }}>{item.tag}</span>}
        </div>
    );

    const handleSiteSelect = (e) => {
        const selectedSite = e.value;
        skipNextSearchClear.current = true;
        HandleUipiodOnClick(selectedSite.uuid);
    };

    useEffect(() => {
        if (skipNextSearchClear.current) {
            skipNextSearchClear.current = false;
            return;
        }
        if (siteSearchTerm) {
            setSiteSearchTerm("");
            setSiteSuggestions([]);
        }
    }, [location.pathname]);

    return (
        <>
            <Modal ref={ModalDialog} title={"Tag site - " + headerData.key} modalName={"Site View"} HandleShowModal={HandleShowModal}>
                <SetTag placeholder={headerData.key} DeviceUUID={headerData.uuid} HandleCloseModal={HandleCloseModal} dispatch={dispatch} update={update} setUpdate={setUpdate} isManualSet={true} headerData={headerData} setHeaderData={setHeaderData}/>
            </Modal>

        <Dialog
            header="Who owns the site?"
            visible={createSiteStep1Visible}
            style={{ width: "40vw" }}
            onHide={() => setCreateSiteStep1Visible(false)}
            >
            <div>
            {/* Choose group */}
               <p>Choose group from the dropdown below</p>
               <Dropdown 
                value={createSiteForGroup} 
                onChange={(e) => setCreateSiteForGroup(e.value)} 
                options={groups} 
                optionLabel="name"
                showClear
                filter
                placeholder="Select a group" 
                className="w-full md:w-14rem" />
            </div>

            <br></br>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button label="Create site" icon="pi pi-plus"severity="success" disabled={!createSiteForGroup} onClick={HandleNextCreateSite} />
            </div>
        </Dialog>


        <Dialog
            header="Create group"
            visible={isCreateGroupVisible}
            style={{ width: "40vw" }}
            onHide={() => { setIsCreateGroupVisible(false); resetCreateGroupForm(); }}
        >
            <div>
                <FloatLabel>
                    <InputText value={createGroupName} onChange={(e) => setCreateGroupName(e.target.value)} />
                    <label>Name</label>
                </FloatLabel>
                <small>Please note group names must be unique and cannot be changed later</small>
                <Divider type="solid" />
                <p>Choose the parent group from the dropdown below</p>
                <Dropdown
                    value={createGroupParent}
                    onChange={(e) => setCreateGroupParent(e.value)}
                    options={groups}
                    optionLabel="name"
                    showClear
                    filter
                    placeholder="Select a group"
                    className="w-full md:w-14rem"
                />
                {showMonitoringStation && (<>
                <Divider type="solid" />
                <p>Choose the monitoring station from the dropdown below.</p>
                <Dropdown
                    value={createGroupMonitoringStation}
                    onChange={(e) => setCreateGroupMonitoringStation(e.value)}
                    options={monitoringStationOptions}
                    optionLabel="name"
                    showClear
                    filter
                    placeholder="Select a monitoring station"
                    className="w-full md:w-14rem"
                />
                <br/>
                <small style={{marginBottom:"15px"}}>This will be the default monitioring station used for newly created sites within this group. You can change this in the Overview page</small>
                </>)}

                {(() => {
                    const availablePerms = [
                        { key: "supportEnabled",     label: "Enable Inniovate ticket creation",       checked: newGroupSupportEnabled,     set: setNewGroupSupportEnabled },
                        { key: "allowSiteCreation",  label: "Allow site creation",  checked: newGroupAllowSiteCreation,  set: setNewGroupAllowSiteCreation },
                        { key: "allowGroupCreation", label: "Allow group creation", checked: newGroupAllowGroupCreation, set: setNewGroupAllowGroupCreation },
                        { key: "billingEnabled",     label: "Enable billing",       checked: newGroupBillingEnabled,     set: setNewGroupBillingEnabled,     eyespyfxOnly: true },
                        { key: "isOnDD",             label: "Is on Direct Debit",   checked: newGroupIsOnDD,             set: setNewGroupIsOnDD,             eyespyfxOnly: true },
                        { key: "isBillableAccount",  label: "Is billable account",   checked: newGroupIsBillableAccount,  set: setNewGroupIsBillableAccount,  eyespyfxOnly: true },
                        { key: "isWhitelabelCustomer", label: "Whitelabel customer",   checked: newGroupIsWhitelabel,       set: setNewGroupIsWhitelabel,       eyespyfxOnly: true },
                        { key: "userInvitesEnabled", label: "User invites enabled",  checked: newGroupUserInvitesEnabled, set: setNewGroupUserInvitesEnabled },
                        { key: "cctvLicensingEnabled", label: "Enable CCTV licensing", checked: newGroupCCTVLicensingEnabled, set: setNewGroupCCTVLicensingEnabled, eyespyfxBypass: true },
                    // eyespyfxBypass items skip the "does my own group have this" check for Inniovate -
                    // matches GroupSites.js's edit-permissions dialog, where e.g. cctvLicensingEnabled is
                    // shown to Inniovate regardless of whether EyeSpyFX's own group row has the flag set,
                    // since they should always be able to grant it to a new subgroup.
                    ].filter(p => (isEyeSpyFX && p.eyespyfxBypass) || (Boolean(myGroup?.[p.key]) && (!p.eyespyfxOnly || isEyeSpyFX)));
                    if (availablePerms.length === 0) return null;
                    return (
                        <>
                            <Divider type="solid" />
                            <p>Permissions</p>
                            <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
                                {availablePerms.map(({ key, label, checked, set }) => (
                                    <div key={key} style={{ display: "flex", alignItems: "center", gap: "12px", cursor: "pointer" }}>
                                        <Checkbox inputId={key} checked={checked} onChange={e => set(e.checked)} />
                                        <label htmlFor={key} style={{ fontSize: "14px", color: "#4a4a4a", cursor: "pointer", userSelect: "none" }}>{label}</label>
                                    </div>
                                ))}
                            </div>
                        </>
                    );
                })()}
            </div>
            <br />
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button icon="pi pi-check" label="Create group" severity="success" disabled={!createGroupParent || !createGroupName} onClick={handleCreateGroup} />
            </div>
        </Dialog>

        <Dialog
            header="Success"
            visible={createGroupSuccessVisible}
            style={{ width: "40vw" }}
            onHide={() => { setCreateGroupSuccessVisible(false); window.location.reload(); }}
        >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Lottie animationData={successAnim} loop={false} style={{ width: 150, height: 150, margin: "0px" }} />
                <br />
                <br />
                <div>
                    <h3 style={{ textAlign: "center", color: "#858585" }}>Group created successfully!</h3>
                    <br />
                    <p style={{ textAlign: "center", color: "#858585" }}>Page will reload for changes to take effect</p>
                </div>
                <br />
                <br />
                <div>
                    <Button icon="pi pi-times" label="Close" severity="secondary" onClick={() => { setCreateGroupSuccessVisible(false); window.location.reload(); }} />
                </div>
            </div>
        </Dialog>

        <Dialog
            header={isDemoCCTVLicenceGrant ? "Grant demo CCTV licence" : "New CCTV license purchase"}
            visible={showCCTVPurchase}
            style={{ width: "40vw" }}
            onHide={() => { setShowCCTVPurchase(false)}}
        >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                {!isDemoCCTVLicenceGrant && (
                    <>
                        <p style={{ margin: "12px 0 0 0", fontSize: "16px", color: "#3d3d3d", lineHeight: 1.6, textAlign: "center" }}>
                           This is a chargeable item and I accept that that our account will be charged at the start of the next invoicing cycle.
                        </p>
                        <p style={{ margin: "12px 0 0 0", fontSize: "15px", color: "#3d3d3d", lineHeight: 1.6, textAlign: "center" }}>
                            This is a one off purchase and can be used over and over again.
                        </p>
                        <br/>
                        <Dropdown
                            value={selectedGroupForLicence}
                            onChange={(e) => setSelectedGroupForLicence(e.value)}
                            options={groups}
                            optionLabel="name"
                            showClear
                            filter
                            placeholder="Select a group"
                            className="w-full md:w-14rem" />
                        <br/>
                    </>
                )}
                <Dropdown
                    value={selectedCCTVLicenceQuantity}
                    onChange={(e) => setSelectedCCTVLicenceQuantity(e.value)}
                    options={[1, 5, 10, 15, 20]}
                    optionLabel="Quantity"
                    showClear
                    filter
                    placeholder="Select number of licences"
                    className="w-full md:w-14rem" />
                <br />

                    <Button
                        label={isDemoCCTVLicenceGrant ? "Grant" : "Continue"}
                        severity="success"
                        icon="pi pi-wallet"
                        onClick={() => isDemoCCTVLicenceGrant ? GrantDemoCCTVLicence() : PurchaseCCTVLicence()}
                    />
<br/>
                    <Button label="Cancel" severity="secondary" icon="pi pi-cross" onClick={() => setShowCCTVPurchase(false)} />

            </div>
        </Dialog>

        <Dialog
            header="Something went wrong"
            visible={createGroupFailVisible}
            style={{ width: "40vw" }}
            onHide={() => setCreateGroupFailVisible(false)}
        >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Lottie animationData={failAnim} loop={false} style={{ width: 150, height: 150, margin: "0px" }} />
                <br />
                <h3 style={{ color: "#6e6e6eff" }}>{createGroupFailMessage}</h3>
                <br />
                <Button icon="pi pi-times" label="Close" rounded severity="secondary" onClick={() => setCreateGroupFailVisible(false)} />
            </div>
        </Dialog>

        <Dialog
            header="Changelog"
            visible={visible}
            style={{ width: "60vw" }}
            onHide={() => setIsVisible(false)}
            >
            <div className="flex gap-4">
                {/* Sidebar selector */}
                <div className="flex flex-col gap-2 w-1/4 border-r pr-2">
                {changelogs.map((log) => (
                    <Button
                    label={log.date} 
                    severity="help"
                    outlined={selected.date !== log.date} 
                    rounded
                    key={log.date}
                    onClick={() => setSelected(log)}
                    style={{marginRight:"10px", marginBottom:"20px"}}
                    />
                    
                   
                ))}
                </div>

                {/* Content */}
                <div className="w-3/4 pl-4" style={{margin:"15px"}}>{selected.content}</div>
            </div>
        </Dialog>

        <Dialog
            header="Give Portal access"
            visible={addUserStep2Visible}
            style={{ width: "40vw" }}
            onHide={() => setAddUserStep2Visible(false)}
            >
            <div className="flex gap-4">
               <AddPortalUser setSuccess={setSuccessVisible} setFail={setShowAddUserFail} groupID={groupID} setShowPrevDialogs={setAddUserStep2Visible} />
            </div>
        </Dialog>

        <Dialog
            header="Which group will they have access to?"
            visible={addUserStep1Visible}
            style={{ width: "40vw" }}
            onHide={() => setAddUserStep1Visible(false)}
            >
            <div>
            {/* Choose group */}
               <p>Choose group from the dropdown below</p>
               <Dropdown 
                value={selectedGroup} 
                onChange={(e) => setSelectedGroup(e.value)} 
                options={groups} 
                optionLabel="name"
                showClear
                filter
                placeholder="Select a group" 
                className="w-full md:w-14rem" />

            </div>

            <br></br>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button label="Next" severity="success" disabled={!selectedGroup} onClick={HandleNext} />
            </div>
        </Dialog>

        <Dialog
            header="Success"
            visible={successVisible}
            style={{ width: "40vw" }}
            onHide={() => setSuccessVisible(false)}
            >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <h3 style={{color:"#6e6e6eff"}}>User added successfully!</h3>
                <Lottie
                    animationData={successAnim}
                    loop={false}
                    style={{ width: 250, height: 250, margin: "0px" }}
                />

                <Button label="Close" icon="pi pi-times" rounded severity="primary" onClick={() => setSuccessVisible(false)}/>
            </div>
        </Dialog>

        <Dialog
            header="Success"
            visible={genericSuccessVisible}
            style={{ width: "40vw" }}
            onHide={() => setGenericSuccessVisible(false)}
            >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <h3 style={{color:"#6e6e6eff"}}>{`${genericSuccessMessage}`}</h3>
                <Lottie
                    animationData={successAnim}
                    loop={false}
                    style={{ width: 250, height: 250, margin: "0px" }}
                />

                <Button label="Close" icon="pi pi-times" rounded severity="primary" onClick={() => setGenericSuccessVisible(false)}/>
            </div>
        </Dialog>

        <Dialog
            header="Error"
            visible={failVisible || showAddUserFail}
            style={{ width: "40vw", maxWidth: '480px' }}
            onHide={() => {setFailVisible(false); setShowAddUserFail(false);}}
            >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "20px" }}>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <Lottie
                        animationData={failAnim}
                        loop={false}
                        style={{ width: 90, height: 90, margin: "0px" }}
                    />

                    <h3 style={{ color: "rgb(147, 147, 147)", fontWeight: "500", fontSize: "16px", margin: "0" }}>
                        {typeof showAddUserFail === 'string' && showAddUserFail.toLowerCase().includes('already member')
                            ? 'User already has Portal access'
                            : 'Please try again.'}
                    </h3>
                </div>
                <div className={classes.btnRow}>
                    <Button label="Close" severity="secondary" onClick={() => {setFailVisible(false); setShowAddUserFail(false); }}/>
                    <br/>
                    <Button label="Create user?" style={{ backgroundColor: 'var(--Primary-Color)', borderColor: 'transparent' }} onClick={HandleCreateUser} />
                </div>
            </div>
        </Dialog>

        <Dialog
            header="Something went wrong"
            visible={genericFailVisible}
            style={{ width: "40vw" }}
            onHide={() => setGenericFailVisible(false)}
            >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <h3 style={{color:"#6e6e6eff", textAlign: "center"}}>{`${genericFailMessage}`}</h3>
                     <Lottie
                    animationData={failAnim}
                    loop={false}
                    style={{ width: 200, height: 200, margin: "0px" }}
                />

            <Button label="Close" rounded severity="primary" icon="pi pi-times"onClick={() => setGenericFailVisible(false)}/>
                
            </div>
        </Dialog>

         <Dialog
            header="Error"
            visible={failCreateUserVisible}
            style={{ width: "40vw" }}
            onHide={() => setFailCreateUserVisible(false)}
            >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <h3 style={{color:"#6e6e6eff", textAlign: "center"}}>Failed to create user, please try again.</h3>
                     <Lottie
                    animationData={failAnim}
                    loop={false}
                    style={{ width: 200, height: 200, margin: "0px" }}
                />

            <Button label="Close" rounded severity="primary" icon="pi pi-times"onClick={() => setFailCreateUserVisible(false)}/>
                
            </div>
        </Dialog>

        <Dialog
            header="Success"
            visible={createSiteSuccessVisible}
            style={{ width: "40vw" }}
            onHide={() => setCreateSiteSuccessVisible(false)}
            >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <h3 style={{color:"#6e6e6eff"}}>Site created successfully!</h3>
                <Lottie
                    animationData={successAnim}
                    loop={false}
                    style={{ width: 250, height: 250, margin: "0px" }}
                />

                <Button label="Go to new site" icon="pi pi-arrow" severity="success" onClick={() => GoToSite()}/>
                <br/>
                <Button label="Close" icon="pi pi-times" severity="secondary" onClick={() => setCreateSiteSuccessVisible(false)}/>
            </div>
        </Dialog>

        <Dialog
            header="Error"
            visible={createSiteFailVisible}
            style={{ width: "40vw" }}
            onHide={() => setCreateSiteFailVisible(false)}
            >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <h3 style={{color:"#6e6e6eff", textAlign: "center"}}>Failed to create site, please try again.</h3>
     
            <Lottie
                animationData={failAnim}
                loop={false}
                style={{ width: 200, height: 200, margin: "0px" }}
            />

            <Button label="Close" severity="primary" icon="pi pi-times"onClick={() => setCreateSiteFailVisible(false)}/>

            </div>
        </Dialog>

        <Dialog
            header="Give Portal access"
            visible={createUserVisible}
            style={{ width: "40vw" }}
            onHide={() => setCreateUserVisible(false)}
            >
            <div className="flex gap-4">
                <CreateUserPortal setSuccessVisible={setSuccessVisible} setFailVisible={setFailVisible} setCreateAccountVisible={setCreateUserVisible} groupID={groupID} />
            </div>
        </Dialog>

        <Dialog
            header="Create user"
            visible={createSingleUserVisible}
            style={{ width: "40vw" }}
            onHide={() => setCreateSingleUserVisible(false)}
            >
            <div className="flex gap-4">
                <CreateUser HandleCloseModal={setCreateSingleUserVisible} setSuccess={setSuccessVisible} setFail={setFailCreateUserVisible} setCreateAccountVisible={setCreateSingleUserVisible} groupID={groupID} apiData={apiData} />
            </div>
        </Dialog>

        <Dialog
            header={`Team — ${companyName}`}
            visible={portalUsersVisible}
            style={{ width: "55vw" }}
            onHide={() => setPortalUsersVisible(false)}
        >
            {(role === "admin" || role === "TechSupport") && (
                <div style={{ display: "flex", justifyContent: "flex-start", marginBottom: "12px" }}>
                    <Button label="Give Portal access" icon="pi pi-user-plus" severity="success" onClick={HandleChooseGroup} />
                </div>
            )}
            {portalUsersLoading ? (
                <div style={{ display: "flex", justifyContent: "center", padding: "40px" }}>
                    <Oval stroke="#6e6e6e" />
                </div>
            ) : Array.isArray(portalUsers) && portalUsers.length > 0 ? (
                <UserList data={portalUsers} isGroup={true} update={portalUsersUpdate} setUpdate={setPortalUsersUpdate} isPortalUsers={true} hidePortalAccess={true} />
            ) : (
                <p style={{ textAlign: "center", color: "#9e9e9e", padding: "40px 0" }}>No portal users found.</p>
            )}
        </Dialog>

            <div className={classes['header-container']}>
                <div className={classes.searchSpacer} />
                    <IconField iconPosition="left" className={classes.searchFieldWrap}>
                        <InputIcon className="pi pi-search" />
                        <AutoComplete
                            value={siteSearchTerm}
                            suggestions={siteSuggestions}
                            completeMethod={searchSites}
                            field="tag"
                            itemTemplate={siteItemTemplate}
                            onChange={(e) => setSiteSearchTerm(e.value)}
                            onSelect={handleSiteSelect}
                            placeholder="Search for a site..."
                            appendTo="self"
                            panelStyle={{ zIndex: 11000}}
                            className={classes.searchBar}
                            inputClassName={classes.searchInput}
                            inputStyle={{ width: "100%", borderRadius: '6px' }}
                        />
                    </IconField>
                <div className={classes.innerContainer}>
                    <div className={classes.right} style={{cursor: "pointer", display: "flex", alignItems: "center", gap: "10px"}}>
                    {supportEnabled && <Button severity="info" className={classes.headerButton} label="Portal help" icon="pi pi-question-circle" onClick={handlePortalHelp}/>}
                    {supportEnabled && <Button severity="secondary" className={classes.headerButton} label="Report an issue" icon="pi pi-send" onClick={handleReportAnIssue}/>}
                    <Button severity="help" outlined className={classes.headerButton} label="What's new?" icon="pi pi-sparkles" onClick={HandleWhatsNew}/>
                    <div className={classes.settingsWrapper} ref={settingsMenuRef}>
                        <div className={classes.accountTrigger} onClick={() => setShowSettingsMenu(prev => !prev)}>
                            <div className={classes.accountInfo}>
                                <span className={classes.accountName}>{userName}</span>
                                {companyName && <span className={classes.accountCompany}>{translateCompanyName(companyName)}</span>}
                                {role && <span className={classes.accountCompany}>{role === "TechSupport" ? "Manager" : role === "admin" ? "Admin" : "Operator"}</span>}
                            </div>
                            <i className={`pi pi-cog ${classes.cogIcon}`} />
                        </div>
                        {showSettingsMenu && (
                            <div className={classes.settingsDropdown}>
                                 {(role === "admin" || role === "TechSupport") && siteCreationEnabled && (
                                <button className={classes.settingsItem} onClick={() => { setShowSettingsMenu(false); HandleCreateSite(); }}>
                                    <i className="pi pi-plus" style={{ marginRight: '8px' }} />
                                    Create site
                                </button>)}
                                {(role === "admin" || role === "TechSupport") && (
                                <button className={classes.settingsItem} onClick={HandleNavigateToTeam}>
                                    <i className="pi pi-users" style={{ marginRight: '8px' }} />
                                    Team
                                </button>)}
                                <button className={classes.settingsItem} onClick={HandleViewAccount}>
                                    <i className="pi pi-user" style={{ marginRight: '8px' }} />
                                    My account
                                </button>
                                 {(role === "admin" || role === "TechSupport") && (
                                    <button className={classes.settingsItem} onClick={HandleCreateSingleUser}>
                                        <i className="pi pi-user-plus" style={{ marginRight: '8px' }} />
                                        Create user
                                    </button>
                                )}
                                {(role === "admin" || role === "TechSupport") && (
                                    <button className={classes.settingsItem} onClick={HandleSettingsGivePortalAccess}>
                                        <i className="pi pi-user-plus" style={{ marginRight: '8px' }} />
                                        Give Portal access
                                    </button>
                                )}
                                {(role === "admin" || role === "TechSupport") && groupCreationEnabled && (
                                    <button className={classes.settingsItem} onClick={HandleSettingsCreateGroup}>
                                        <i className="pi pi-folder-plus" style={{ marginRight: '8px' }} />
                                        Create group
                                    </button>
                                )}
                                {(role === "admin" || role === "TechSupport") && showPurchaseCCTVLicence && (
                                    <button className={classes.settingsItem} onClick={HandlePurchaseCCTVLicence}>
                                        <i className="pi pi-wallet" style={{ marginRight: '8px' }} />
                                        Purchase CCTV licence
                                    </button>
                                )}
                                {/* <button className={classes.settingsItem} onClick={() => setIsDark(d => !d)}>
                                    <i className={`pi ${isDark ? 'pi-sun' : 'pi-moon'}`} style={{ marginRight: '8px' }} />
                                    {isDark ? 'Light mode' : 'Dark mode'}
                                </button> */}
                                <hr className={classes.settingsDivider} />
                                <button className={classes.settingsItem} onClick={HandleSettingsLogout}>
                                    <i className="pi pi-sign-out" style={{ marginRight: '8px' }} />
                                    Logout
                                </button>
                            </div>
                        )}
                    </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Header;